import { MouseEventHandler, memo, Fragment, ComponentType } from 'react';

import { DevHubBox, DevHubButton, DevHubModal } from '@devxdiscover/devhub-ui';

type Props = {
  handleClose: MouseEventHandler<HTMLButtonElement>;
  open: boolean;
  modalContent: ComponentType<any>;
};

/**
 * DevHubModal Content component
 * @param props Props passed to the component
 */
export const PluginModal = memo((props: Props) => {
  const ModalContent = props.modalContent;

  return (
    <DevHubModal
      open={props.open}
      onClose={props.handleClose}
      closeAfterTransition
    >
      <Fragment>
        <ModalContent />
        <DevHubBox display="flex" justifyContent="center" m={2}>
          <DevHubButton
            height="large"
            variant="contained"
            color="primary"
            onClick={props.handleClose}
          >
            Close
          </DevHubButton>
        </DevHubBox>
      </Fragment>
    </DevHubModal>
  );
});
